// extracted by mini-css-extract-plugin
export default {"container":"SectionGraficos_container__vDmmR"};